module.exports = __webpack_public_path__ + "img/download-dent-red.90133f75.svg";